<ix-modal-header [title]="title" [loading]="isFormLoading"></ix-modal-header>

<mat-card>
  <mat-card-content>
    <form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
      <ix-fieldset [title]="'Group Configuration' | translate">
        <ix-input
          formControlName="gid"
          label="GID"
          [required]="true"
          [tooltip]="tooltips.gid"
        ></ix-input>

        <ix-input
          formControlName="name"
          [label]="'Name' | translate"
          [required]="true"
          [tooltip]="tooltips.name"
        ></ix-input>

        <ix-chips
          formControlName="sudo_commands"
          [label]="'Allowed sudo commands' | translate"
        ></ix-chips>

        <ix-checkbox
          formControlName="sudo_commands_all"
          [label]="'Allow all sudo commands' | translate"
        ></ix-checkbox>

        <ix-chips
          formControlName="sudo_commands_nopasswd"
          [label]="'Allowed sudo commands with no password' | translate"
        ></ix-chips>

        <ix-checkbox
          formControlName="sudo_commands_nopasswd_all"
          [label]="'Allow all sudo commands with no password' | translate"
        ></ix-checkbox>

        <ix-checkbox
          formControlName="smb"
          [label]="'Samba Authentication' | translate"
          [tooltip]="tooltips.smb"
        ></ix-checkbox>

        <ix-checkbox
          *ngIf="isNew"
          formControlName="allowDuplicateGid"
          [label]="'Allow Duplicate GIDs' | translate"
          [tooltip]="tooltips.allowDuplicateGid"
        ></ix-checkbox>
      </ix-fieldset>

      <ix-form-actions>
        <button
          mat-button
          type="submit"
          color="primary"
          ixTest="save"
          [disabled]="form.invalid || isFormLoading"
        >
          {{ 'Save' | translate }}
        </button>
      </ix-form-actions>
    </form>
  </mat-card-content>
</mat-card>
